import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { styled }, "@mui/material/Box": Box, "@mui/material/Paper": Paper, "@mui/material/Grid": Grid, "@mui/material/Stack": Stack } } });
export default ClientProvider;
